import { t } from "../../../../i18n";
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput, Stack, Typography } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import AnimateButton from '../../../../component/extended/AnimateButton';
import { useSignIn } from 'hooks/useAuth';

// ============================|| FIREBASE - LOGIN ||============================ //

function FirebaseLogin({
  onUseEmailOtp,
  ...others
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(true);
  const formikSignIn = useSignIn();
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = event => {
    event.preventDefault();
  };
  return <form noValidate onSubmit={formikSignIn.handleSubmit} {...others}>
            <FormControl fullWidth error={Boolean((formikSignIn.touched.email || formikSignIn.submitCount > 0) && formikSignIn.errors.email)} sx={{
      ...theme.typography.customInput
    }}>
                <InputLabel htmlFor="outlined-adornment-email-login">{t("Email")}</InputLabel>
                <OutlinedInput id="outlined-adornment-email-login" type="email" value={formikSignIn.values.email} name="email" onBlur={formikSignIn.handleBlur} onChange={formikSignIn.handleChange} label={t("Email")} autoComplete="email" inputProps={{}} />
                {(formikSignIn.touched.email || formikSignIn.submitCount > 0) && t(formikSignIn.errors.email) && <FormHelperText error id="standard-weight-helper-text-email-login">
                            {t(formikSignIn.errors.email)}
                        </FormHelperText>}
            </FormControl>

            <FormControl fullWidth error={Boolean((formikSignIn.touched.password || formikSignIn.submitCount > 0) && formikSignIn.errors.password)} sx={{
      ...theme.typography.customInput
    }}>
                <InputLabel htmlFor="outlined-adornment-password-login">{t("Password")}</InputLabel>
                <OutlinedInput id="outlined-adornment-password-login" type={showPassword ? 'text' : 'password'} value={formikSignIn.values.password} name="password" onBlur={formikSignIn.handleBlur} onChange={formikSignIn.handleChange} endAdornment={<InputAdornment position="end">
                            <IconButton aria-label={t("toggle password visibility")} onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end" size="large">
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>} label={t("Password")} autoComplete="current-password" inputProps={{}} />
                {(formikSignIn.touched.password || formikSignIn.submitCount > 0) && t(formikSignIn.errors.password) && <FormHelperText error id="standard-weight-helper-text-password-login">
                            {t(formikSignIn.errors.password)}
                        </FormHelperText>}
            </FormControl>
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                <FormControlLabel control={<Checkbox checked={checked} onChange={event => setChecked(event.target.checked)} name="checked" color="primary" />} label={t("Lembrar-se de mim")} />
                <Typography variant="subtitle1" color="accent.main" sx={{
        textDecoration: 'none',
        cursor: 'pointer'
      }} component="a" onClick={() => navigate('/forgetPassword')}>{t("Não consegue fazer log in?")}</Typography>
            </Stack>
            {t(formikSignIn.errors.submit) && <Box sx={{
      mt: 3
    }}>
                    <FormHelperText error>{t(formikSignIn.errors.submit)}</FormHelperText>
                </Box>}

            <Box sx={{
      mt: 2
    }}>
                <AnimateButton>
                    <Button disableElevation disabled={formikSignIn.isSubmitting} fullWidth size="large" type="submit" variant="contained" color="secondary" name="submit">{t("Log in")}</Button>
                </AnimateButton>
            </Box>
            <Button type="button" variant="text" fullWidth sx={{
      mt: 1,
      '&:not(.Mui-disabled)': {
        color: 'accent.main'
      }
    }} disabled={formikSignIn.isSubmitting} onClick={onUseEmailOtp}>{t("Entrar com código por email")}</Button>
        </form>;
}
FirebaseLogin.propTypes = {
  onUseEmailOtp: PropTypes.func.isRequired
};
export default FirebaseLogin;
